<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1">Text and photography copyright © 2023 by Lesley Riley</p>
<p class="copy">Photography and artwork copyright © 2023 by C&amp;T Publishing, Inc.</p>
<p class="copy">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Senior Editor: Roxane Cerda</p>
<p class="copy">Editor: Liz Aneloski</p>
<p class="copy">Technical Editor: Helen Frost</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Photography Coordinator: Lauren Herberg</p>
<p class="copy">Photography Assistant: Rachel Ackley</p>
<p class="copy">Front cover photography: Top row by Lauren Herberg for C&amp;T Publishing, middle row by Kyle Gula, bottom row by Lesley Riley</p>
<p class="copy">Photography by Lesley Riley, unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
<p class="fig"><img alt="" src="images/pg1_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyright.vue?6ff65579